import Footer from './Assets/Footer.js'
import Header from './Assets/Header.js'
import {Link} from 'react-router-dom'
import Button from './Assets/Button.js'

function TutorsProfilePage() {
    return (
        <>
        <Header/>
        <section class="TP-Profile">
            <img src={require("../TutorImage.jpg")} alt="Tutor" class="TP-Image-Fixed"/>
            <div>
                <img src={require("../TutorImage.jpg")} alt="Tutor" class="TP-Image"/>
                <div>
                    <h1>Tutor Profile</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                    <Button path="/booking-page" name="Book Now" style="Button"/>
                </div>
            </div>
        </section>
        <section class="TP-Info">
            <div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum. </p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum. </p>
            </div>
        </section>
        <Footer/>
        </>
    )
}

export default TutorsProfilePage